module.exports = __webpack_public_path__ + "img/icon-sun.d8ea436b.svg";